import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import type { ActivityEvent } from "@/components/ui/ActivityFeed/types";

// ─── Status color map ────────────────────────────────────────────────────────

type BadgeClasses = string;

function getStatusBadgeClasses(status: string): BadgeClasses {
  const key = status.toLowerCase().replace(/\s+/g, "_");
  switch (key) {
    case "submitted":
      return "bg-blue-500/10 text-blue-600 border-blue-300/50";
    case "in_review":
    case "in_progress":
      return "bg-amber-500/10 text-amber-600 border-amber-300/50";
    case "approved":
      return "bg-green-500/10 text-green-600 border-green-300/50";
    case "rejected":
      return "bg-red-500/10 text-red-600 border-red-300/50";
    case "archived":
      return "bg-card text-muted border-border/60";
    default:
      return "bg-card text-secondary border-border/60";
  }
}

const BADGE_BASE =
  "inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-medium border capitalize";

// ─── Renderer function ───────────────────────────────────────────────────────

export function renderAuditStatusChange(event: ActivityEvent): ReactNode {
  const from =
    event.metadata?.from ??
    event.metadata?.previousStatus ??
    event.metadata?.oldStatus;
  const to =
    event.metadata?.to ?? event.metadata?.newStatus ?? event.metadata?.status;

  if (!from || !to || from === to) return null;

  return (
    <div className="flex items-center gap-1.5 mt-1.5">
      <span className={`${BADGE_BASE} ${getStatusBadgeClasses(from)}`}>
        {from}
      </span>
      <ArrowRight size={11} className="text-muted shrink-0" />
      <span className={`${BADGE_BASE} ${getStatusBadgeClasses(to)}`}>{to}</span>
    </div>
  );
}
